export const genUID = (): string =>
  Math.floor((1 + Math.random()) * 0x1000000)
    .toString(16)
    .substring(1);
